module.exports = __webpack_public_path__ + "static/media/15-5.5a3f0dce.mp3";